import UserLogin from '@/common/containers/Forms/UserLogin/UserLogin';

export default UserLogin;
